import { PortalContext } from "App";
import { useContext } from "react";

/**
 * hook to simplify access to page state
 *
 * @param {Object} props
 * @param {String} props.pagePath The page path of the caller
 * @returns
 */
const usePageState = ({ pagePath }) => {
  const stateContext = useContext(PortalContext);
  const { detailPageState } = stateContext;

  const sessionState = JSON.parse(sessionStorage.getItem("state"));
  // note: upon refresh, detailPageState will not be immediately available yet, so we need to fallback to the session state (which is identical, but with a different reference)
  // this however, triggers multiple re-renders, which is not ideal
  return detailPageState?.[pagePath] || sessionState?.[pagePath] || {};
};

export default usePageState;
